module.exports = __webpack_public_path__ + "img/salon_thumbnail-600x450.1eef3f99.jpg";